import React, { useEffect } from "react";
import "./index.scss";
import back from "assets/images/back.svg";
import { formSteps as steps } from "config/formSteps";

import FormHeader from "./FormHeader";
import FormStepContent from "./FormStepContent";
import FormFooter from "./FormFooter";

import useFormLogic from "hooks/useFormLogic";

const HomePage = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const timeout = 10; // minutes

  const {
    stepIndex,
    currentStep,
    selectedOption,
    setSelectedOption,
    textGridValues,
    setTextGridValues,
    handleBack,
    handleNext,
    isNextDisabled,
    stepsLength,
    answers,
    creditors,
    validationErrors,
    handleFieldBlur,
    onFinish,
  } = useFormLogic(steps, apiBaseUrl, timeout);

  useEffect(() => {
    steps.forEach((step) => {
      const img = new Image();
      img.src = step.icon;
    });
  }, []);

  return (
    <div className="user_from">
      <FormHeader
        stepIndex={stepIndex}
        handleBack={handleBack}
        stepsLength={stepsLength}
      />

      {stepIndex !== stepsLength - 1 && stepIndex > 0 && (
        <div className="user_from__back-icon-wrapper">
          <img
            src={back}
            alt="Back Icon"
            className="user_from__back-icon"
            onClick={handleBack}
          />
        </div>
      )}

      <FormStepContent
        currentStep={currentStep}
        creditors={creditors}
        stepIndex={stepIndex}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
        textGridValues={textGridValues}
        setTextGridValues={setTextGridValues}
        onFieldBlur={handleFieldBlur}
        validationErrors={validationErrors}
        handleNext={handleNext}
        isNextDisabled={isNextDisabled}
        stepsLength={stepsLength}
        onFinish={() => onFinish(answers)}
      />

      <FormFooter footer={currentStep.footer} />

      {/* <div style={{ flex: 1 }}></div> */}
    </div>
  );
};

export default HomePage;
